import { render, staticRenderFns } from "./TestType.vue?vue&type=template&id=e51074f6&scoped=true&"
import script from "./TestType.vue?vue&type=script&lang=js&"
export * from "./TestType.vue?vue&type=script&lang=js&"
import style0 from "./TestType.vue?vue&type=style&index=0&id=e51074f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51074f6",
  null
  
)

export default component.exports